import React from 'react';
import { motion } from 'framer-motion';
export const Community = () => {
  const events = [{
    title: 'Open Praise Nights',
    description: 'Weekly fellowship gatherings where all are welcome to worship through song and celebration.',
    image: 'https://cdn.magicpatterns.com/uploads/met4dr7dARnS9eRiMSu75i/adrianna-geo-W5oBN7u4yfw-unsplash-scaled-1.jpg'
  }, {
    title: 'Worship Voice Workshops',
    description: 'Learn to use your voice as an instrument of worship and praise to glorify God.',
    image: 'https://cdn.magicpatterns.com/uploads/6MLqHKr284Z16owZhxwHWy/simple_worship_sing_along_videos_ceccs.webp'
  }, {
    title: 'The Great Gathering',
    description: 'Monthly worship celebration where our fellowship comes together for an unforgettable night of praise.',
    image: 'https://images.unsplash.com/photo-1473177104440-ffee2f376098?w=1950&q=80'
  }];
  const testimonials = [{
    quote: 'I came to sing. I left feeling closer to God than ever.',
    author: 'Tara J.'
  }, {
    quote: 'My voice found its purpose in this place of worship.',
    author: 'Marcus W.'
  }, {
    quote: 'The fellowship and praise we share here changed my life.',
    author: 'Leila K.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-brand-black to-brand-charcoal" data-id="element-24">
      <div className="max-w-6xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-26">
          <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6 text-white" data-id="element-27">
            Our Community
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto mb-10" data-id="element-28"></div>
          <p className="text-xl max-w-3xl mx-auto text-white/90" data-id="element-29">
            Join a growing fellowship of believers lifting their voices in
            worship, praise, and celebration.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-30">
          {events.map((event, index) => <div key={index} className="bg-brand-charcoal/50 rounded-lg overflow-hidden border border-brand-red/20" data-id="element-31">
              <div className="h-48 relative" data-id="element-32">
                <img src={event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-33" />
                <div className="absolute inset-0 bg-black/40" data-id="element-34"></div>
              </div>
              <div className="p-6" data-id="element-35">
                <h3 className="font-display text-xl font-bold mb-3 text-white" data-id="element-36">
                  {event.title}
                </h3>
                <p className="text-white/70" data-id="element-37">{event.description}</p>
              </div>
            </div>)}
        </motion.div>
        <div className="bg-brand-charcoal/30 rounded-lg p-8 md:p-12 border border-brand-red/20" data-id="element-38">
          <h3 className="font-display text-2xl text-center font-bold mb-8 text-white" data-id="element-39">
            Voices of the Community
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-40">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: index * 0.2
          }} className="bg-brand-charcoal/50 p-6 rounded-lg border border-brand-red/10" data-id="element-41">
                <blockquote className="text-lg italic mb-4 text-white/90" data-id="element-42">
                  "{testimonial.quote}"
                </blockquote>
                <p className="text-right text-brand-red font-semibold" data-id="element-43">
                  {testimonial.author}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};